// src/utils/loadImages.js
function importAll(r) {
    let images = {};
    r.keys().forEach((item) => {
      images[item.replace('./', '')] = r(item);
    });
    return images;
  }
  
  const images = process.env.NODE_ENV === 'test'
    ? {}
    : importAll(require.context('../assets', false, /\.(png|jpe?g|svg)$/));
  
  export default images;
  
